module.exports = "/_next/static/images/a1a4960f9a8b18b8daddbe22c8655eb7-hero-lg.jpg";